const slideValidation = async (fields, action) => {
    for (const item of fields) {
        if (!await action(item)) {
            var elementCheck = document.getElementById(item);
            if (elementCheck) { elementCheck.focus(); }
            return item;
        }else{
          console.log("invalid" + document.getElementById(item)?.value + "abcs");
        }
    }
    return 'Success';
};

const numberValidation = (evt) => {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode; 
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
        return false;
    }
    else {
        return true;
    }
}

const nameValidate = (evt) => {
    const char = String.fromCharCode(evt.charCode);
    if (!/^[a-zA-Z\s]*$/.test(char)) {
        evt.preventDefault();
        return false;
    }
    evt.target.value = evt.target.value.trimStart();
}


const firstNameValidate = (evt) => {
    const char = String.fromCharCode(evt.charCode);
    const maxLength = 15;
    if (!/^[a-zA-Z\s]*$/.test(char)) {
        evt.preventDefault();
        return false;
    }
    evt.target.value = evt.target.value.trimStart();
    if (evt.target.value.length >= maxLength) {
        evt.preventDefault();
        return false;
    }
}

const dobValidation = (DobDay, DobMonth, DobYear) => {
    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const month = monthNames.indexOf(DobMonth) !== -1 ? monthNames.indexOf(DobMonth) + 1 : null;
    var date = new Date(parseInt(DobYear), parseInt(month) - 1, parseInt(DobDay));
    var dateStatus = parseInt(month) == date.getMonth() + 1;

    return dateStatus;
}

const handleCreditCheckFailure = () =>{

    const formData = JSON.parse(localStorage.getItem('formData')) || {};
    const creditCheckApiStatus = JSON.parse(localStorage.getItem('creditCheckApiResponse')) || {};
    const selectedBanks = JSON.parse(localStorage.getItem('selectedBanks')) || [];
    const isCreditCheckError = ["Verification error", "Internal error","Client Not Found"].includes(creditCheckApiStatus.message);
    const hasValidSignatureData = formData.signatureData == 1;
    const isSelectedBanksValid = selectedBanks.length > 0;
    if (isCreditCheckError && hasValidSignatureData && isSelectedBanksValid) {
        return 1;
    }else{
    return 0;
    }


}


const handleCreditCheckFailureFollowup = () =>{

    const pendingDetails = JSON.parse(localStorage.getItem('pendingArrayData')) || {};
    const creditCheckApiStatus = JSON.parse(localStorage.getItem('creditCheckApiResponse')) || {};
    const selectedBanks = JSON.parse(localStorage.getItem('userBankList')) || [];
    const isCreditCheckError = ["Verification error", "Internal error", "Client Not Found"].includes(creditCheckApiStatus.message);
    const isUserSignValid = pendingDetails.is_user_sign === 1; 
    const isSelectedBanksValid = selectedBanks.length > 0;
    if (isCreditCheckError &&  isUserSignValid && isSelectedBanksValid) {
        return 1;
    }else{
    return 0;
    }
}
const fetchCreditCheckBasicData = (userInfo) => {
    const monthNames = [
        "January", "February", "March", "April", "May", "June", 
        "July", "August", "September", "October", "November", "December"
      ];
    const dobMonth = userInfo.DobMonth;
    const monthNumber = parseInt(dobMonth, 10);
    const monthName =
      monthNumber > 0 && monthNumber <= 12
        ? monthNames[monthNumber - 1]
        : "Invalid Month";
    const basicUserData = {
      lstSalutation: userInfo.salutation,
      txtFName: userInfo.first_name,
      txtLName: userInfo.last_name,
      DobDay: userInfo.DobDay,
      DobMonth: monthName,
      DobYear: userInfo.DobYear,
      txtPostCode: userInfo.post_code,
      address1: userInfo.address1,
      txtHouseNumber: userInfo.house_number,
      txtAddress2: userInfo.address2,
      txtAddress3: userInfo.address3,
      txtCounty: userInfo.county,
      txtTown: userInfo.town,
      txtCountry: userInfo.country,
      txtDistrict: userInfo.district,
      txtPhone: userInfo.telephone,
      txtEmail:userInfo.email, 
      txtAddress4: userInfo.address4,
      vendor: userInfo.vendor,
    };
    return basicUserData;
  }
  const handleCreditCheckFailureV8A = () =>{

    const formData = JSON.parse(localStorage.getItem('formData')) || {};
    const creditCheckApiStatus = JSON.parse(localStorage.getItem('creditCheckApiResponse')) || {};
    const selectedBanks = JSON.parse(localStorage.getItem('selectedBanks')) || [];
    const isCreditCheckError = ["Verification error", "Internal error","Client Not Found"].includes(creditCheckApiStatus.message);
    const hasValidSignatureData = formData.signatureData == 1;
    const isSelectedBanksValid = selectedBanks.length > 0;
    if (isCreditCheckError && hasValidSignatureData) {
        return 1;
    }else{
    return 0;
    }


}

export { slideValidation, numberValidation, nameValidate, dobValidation, firstNameValidate, handleCreditCheckFailure, handleCreditCheckFailureFollowup, fetchCreditCheckBasicData, handleCreditCheckFailureV8A}


